import React, { useEffect, useState } from "react";
import { getCoupons, deleteCoupon } from "../../api/couponService";
import { FaEye, FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import Pagination from "../Pagination/Pagination";
import { useNavigate } from "react-router-dom";
export default function CouponList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const navigate = useNavigate();
  // FIXED DATE FORMAT (DD/MM/YYYY)
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };
  // LOAD DATA
 const loadData = async () => {
  try {
    setLoading(true);

    const res = await getCoupons(currentPage, itemsPerPage);

    const data = Array.isArray(res?.data) ? res.data : [];
    const pagination = res?.pagination || {};

    setList(data);

   setTotalItems(
  pagination?.total ||
  data.length ||
  0
);

    setError("");
  } catch (err) {
    setError("Failed to load coupons");
    setList([]);
  } finally {
    setLoading(false);
  }
};
 useEffect(() => {
  loadData();
}, [currentPage]);
  // DELETE
  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Delete this coupon?")) return;
      await deleteCoupon(id);
      const response = await deleteCoupon(id);
      setSuccess("Coupon deleted successfully");
      loadData();
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to delete coupon");
      setTimeout(() => setError(""), 3000);
    }
  };
  if (loading) {
    return (
      <div className="d-flex vh-100 align-items-center justify-content-center">
        Loading Coupons...
      </div>
    );
  }
  return (
    <div className="container-fluid p-4">
      {success && <div className="alert alert-success">{success}</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>Coupon List</h5>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/coupon/add")}
        >
          <FaPlus /> Add Coupon
        </button>
      </div>
      {/* TABLE */}
      <div className="card p-3">
        <table className="table table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th className="text-dark fw-bold">#</th>
              <th className="text-dark fw-bold">Title</th>
              <th className="text-dark fw-bold">Code</th>
              <th className="text-dark fw-bold">Discount Value</th>
              <th className="text-dark fw-bold">Min  Amount</th>
              <th className="text-dark fw-bold">Max  Amount</th>
              <th className="text-dark fw-bold">Start Date</th>
              <th className="text-dark fw-bold">Expiry Date</th>
              <th className="text-dark fw-bold">Status</th>
              <th className="text-dark fw-bold">Action</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center">
                  No Coupons Found
                </td>
              </tr>
            ) : (
              list.map((c, index) => (
                <tr key={c._id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{c.title}</td>
                  <td>{c.code}</td>
                  <td>{c.discountValue}</td>
                  <td>₹{c.minOrderAmount}</td>
                  <td>₹{c.maxDiscountAmount}</td>

                  <td>{formatDate(c.startDate)}</td>
                  <td>{formatDate(c.expiryDate)}</td>

                  <td>
                    <span
                      className={`badge ${c.status === "ACTIVE" ? "bg-success" : "bg-danger"
                        }`}
                    >
                      {c.status}
                    </span>
                  </td>



                  <td>
                    <div className="d-flex gap-2">
                      <FaEye
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/coupon/view/${c.code}`, {
                            state: { couponId: c._id },
                          })
                        }
                      />
                      <FaEdit
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/coupon/edit/${c.code}`, {
                            state: { couponId: c._id },
                          })
                        }
                      />
                      <FaTrash
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(c._id)}

                      />
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
       </div>
        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      
    </div>
  );
}
